import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=1dda1775&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"
import style0 from "./tax.vue?vue&type=style&index=0&id=1dda1775&prod&lang=scss&scoped=true&"
import style1 from "./tax.vue?vue&type=style&index=1&id=1dda1775&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda1775",
  null
  
)

export default component.exports